<!-- keep-localization-pattern: ^locale\..*\.(long|short)$ -->
@if (availableLocales$ | async; as availableLocales) { @if (availableLocales.length > 1) { @if (locale$ | async; as
locale) {
<div
  class="custom-language-switch"
  [ngClass]="view()"
  ngbDropdown
  placement="{{ placement() === 'up' ? 'top-right' : 'bottom-right' }}"
>
  <a ngbDropdownToggle class="language-switch-link" role="button" aria-haspopup="menu">
    <span class="d-flex d-md-none">{{ 'dias.mobile.header.language.text' | translate }}</span>
    <i class="icon-align-right language-icons"></i>
  </a>
  <div ngbDropdownMenu class="language-switch-container dropdown-menu" style="left: 0 !important" role="menu">
    <div class="language-switch-menu-container">
      @if (availableLocales.length > 1) {
      <ul>
        @for (l of availableLocales; track l) { @if (l !== locale) {
        <li>
          <a
            [href]="location | ishMakeHref : { lang: l } | async"
            (click)="setLocaleCookie(l)"
            role="menuitem"
            class="locale-link"
          >
            {{ 'locale.' + l + '.long' | translate }}
          </a>
        </li>
        } }
      </ul>
      }
    </div>
  </div>
</div>
} } }
